import { FormattedMessage } from 'react-intl';
import { useUnreadCount } from '../care-team/hooks/store/useUnreadCount';
import { UnreadBadge } from '@xolv-mybrightlink/common';

export const CommunityTabTitle = () => {
  const communityUnreadCount = useUnreadCount({
    type: 'channelType',
    channelType: 'PEER_TO_PEER',
  });
  return (
    <UnreadBadge count={communityUnreadCount}>
      <FormattedMessage id='messages.community' />
    </UnreadBadge>
  );
};
